// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* API Settings, Monitor and provenance on the canvas. The panel is the shared
   ../packages/publishing/CatalogDrawerShell.module.css; this sets its tier. */
.Ky6WCn1tx4aHRVi0kyvs {
  --curio-drawer-z: var(--curio-z-header-drawer);
}
`, "",{"version":3,"sources":["webpack://./src/components/layout/HeaderDrawer.module.css"],"names":[],"mappings":"AAAA;8EAC8E;AAC9E;EACE,8CAA8C;AAChD","sourcesContent":["/* API Settings, Monitor and provenance on the canvas. The panel is the shared\n   ../packages/publishing/CatalogDrawerShell.module.css; this sets its tier. */\n.overlayRoot {\n  --curio-drawer-z: var(--curio-z-header-drawer);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"overlayRoot": `Ky6WCn1tx4aHRVi0kyvs`
};
export default ___CSS_LOADER_EXPORT___;
